import React from 'react';
import Slider from 'bootstrap-slider';

class SlideredNumberSetting extends React.Component {
  componentDidMount() {
    this.initSlider();
  }
  componentWillUnmount() {
    this.slider.destroy();
  }

  initSlider() {
    const sliderAttributes = {
      ...this.props,
      tooltip: this.props.tooltip || "hide"
    };
    this.slider = new Slider(this.node, sliderAttributes);
    this.slider.on("change", e => {
      this.props.onChange(e.newValue.toString());
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.slider.setValue(this.props.value);
    }
    if (prevProps.max !== this.props.max) {
      this.slider.destroy();
      this.initSlider();
    }
  }

  render() {
    const { label, value, note, isDisabled = false, displayInput = true } = this.props;
    return (
      <div className="form-group">
        <label>{label}</label>
        { note &&
          <span className="pull-right">{note}</span>
        }
        <div className={`fantastic-slider ${isDisabled ? 'fantastic-slider_disabled' : ''}`}>
          <div ref={node => (this.node = node)} />
        </div>
        { (displayInput && value) &&
          <input
            type="number"
            min="0"
            value={value}
            className="form-control fantastic-form-control"
            onChange={(e) => this.props.onChange(e.target.value)}
          />
        }
      </div>
    );
  }
};

export default SlideredNumberSetting;
